// Tour step definitions. Each step: {target?: testid, title, body, route?, placement, action?}
// If `route` is set, the tour navigates there before showing. If `target` matches a
// data-testid on that page, a spotlight highlights it.

export const TOURS = {
  "crear-factura": {
    title: "Crea tu primera factura",
    emoji: "🧾",
    intro: "Vamos a hacer tu primer CFDI paso a paso. Yo te guío en la app real, tú sólo llenas los datos.",
    steps: [
      {
        route: "/facturacion",
        target: "billing-heading",
        title: "1. Bienvenido a Facturación",
        body: "Ésta es la pantalla oficial para timbrar CFDIs. Vamos a llenar 4 datos súper simples y luego verás la pro-forma antes de emitir.",
        placement: "bottom",
      },
      {
        route: "/facturacion",
        target: "billing-client-name-input",
        title: "2. ¿Quién es tu cliente?",
        body: "Escribe el nombre o razón social del cliente. Si ya lo tienes guardado en Clientes, aparecerá para autocompletar.",
        placement: "bottom",
      },
      {
        route: "/facturacion",
        target: "billing-client-rfc-input",
        title: "3. RFC + Código postal",
        body: "El RFC de tu cliente (12 o 13 caracteres) y su código postal fiscal. Los sacas de su Constancia de Situación Fiscal.",
        placement: "bottom",
      },
      {
        route: "/facturacion",
        target: "billing-description-input",
        title: "4. ¿Qué le vendiste?",
        body: "Describe brevemente: por ejemplo 'Servicio de diseño de logotipo'. Luego pon cantidad y precio SIN IVA — la app calcula el 16% sola.",
        placement: "top",
      },
      {
        route: "/facturacion",
        target: "show-proforma-button",
        title: "5. Ver pro-forma",
        body: "Toca este botón para ver cómo quedaría la factura ANTES de timbrarla. Todavía no se emite nada — es sólo un borrador.",
        placement: "top",
      },
      {
        route: "/facturacion",
        target: "emit-invoice-button",
        title: "6. Emitir la factura oficial",
        body: "Cuando todo se vea bien, este botón timbra la factura ante el SAT vía Facturapi y le manda PDF y XML al cliente por correo. ¡Ya está!",
        placement: "top",
      },
    ],
  },

  "preparar-declaracion": {
    title: "Prepara tu declaración mensual",
    emoji: "📊",
    intro: "Te guío por el módulo de Declaraciones para que armes tu declaración provisional en 5 pasos.",
    steps: [
      {
        route: "/declaraciones",
        target: "declarations-current",
        title: "1. Tu declaración del mes",
        body: "Aquí ves el mes actual. La app suma automáticamente tus ingresos y egresos según lo que tengas registrado en la app.",
        placement: "bottom",
      },
      {
        route: "/declaraciones",
        target: "declarations-progress",
        title: "2. Barra de avance",
        body: "Este porcentaje muestra qué tan completa está tu declaración. Cuando llegue a 100%, ya tienes todos los datos que el SAT necesita.",
        placement: "bottom",
      },
      {
        route: "/declaraciones",
        target: "declarations-open-checklist",
        title: "3. Revisa el checklist",
        body: "Este botón abre la lista de datos faltantes. Cada línea roja te dice exactamente qué te falta (ej: subir un CFDI, categorizar un gasto).",
        placement: "bottom",
      },
      {
        route: "/declaraciones",
        target: "declarations-kpis",
        title: "4. Números clave",
        body: "Fíjate en 4 números: Ingresos, Egresos deducibles, ISR estimado, IVA neto. Con estos 4 se arma tu declaración provisional.",
        placement: "top",
      },
      {
        route: "/declaraciones",
        target: "declarations-prepare-button",
        title: "5. Preparar y guardar",
        body: "Este botón te hace 2 preguntas cortas (¿declaras en ceros?) y guarda la declaración lista para que la presentes en sat.gob.mx o se la pases a tu contador.",
        placement: "top",
      },
    ],
  },
};

export function getTour(slug) {
  return TOURS[slug] || null;
}
